import styled from 'styled-components';

export const Container = styled.div`
  padding-top: 180px;
  padding-left: 28px;
  padding-right: 28px;
  display: flex;
  justify-content: center;
  @media (max-width: 600px) {
    padding-top: 117px;
  }
`;

export const InnerContainer = styled.div`
  width: 80%;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const HeadingText = styled.div`
  font-weight: bold;
  font-size: 56px;
  line-height: 130%;
  max-width: 684px;
  @media (max-width: 600px) {
    font-size: 32px;
    line-height: 42px;
  }
`;

export const Text = styled.div`
  font-size: 18px;
  line-height: 130%;
  color: #878d96;
  margin-top: 14px;
  margin-bottom: 23px;
  max-width: 684px;
  @media (max-width: 600px) {
    margin-top: 10px;
    margin-bottom: 40px;
    font-size: 16px;
  }
`;

export const GetStartedButton = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1.1rem 1.6rem 1.1rem 1.82rem;
  width: 14rem;
  gap: 0.625rem;
  background: black;
  border-radius: 0.5rem;
  color: #ffffff;
  font-family: var(--font-family-circular);
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 130%;
  text-align: center;
  border: none;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const RequestDemoButton = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 20px;
  gap: 10px;
  background: #f7f6fa;
  border: 2px solid #b4a1d1;
  border-radius: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  color: #6944a3;
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }
  @media (min-width: 600px) {
    display: none;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 60px 0 100px;
`;

export const ImageContainer = styled.div`
  margin-top: 84px;
  overflow-x: scroll;
  border-radius: 20px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  @media (max-width: 600px) {
    margin-top: 38px;
    margin-right: -28px;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  @media (max-width: 600px) {
    min-width: 1168px;
  }
`;
